import { render, staticRenderFns } from "./ChatComment.vue?vue&type=template&id=d3a6784e&scoped=true&"
import script from "./ChatComment.vue?vue&type=script&lang=ts&"
export * from "./ChatComment.vue?vue&type=script&lang=ts&"
import style0 from "./ChatComment.vue?vue&type=style&index=0&id=d3a6784e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a6784e",
  null
  
)

export default component.exports